import script from "./AdminCreateAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminCreateAdmin.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/sites/AdminCreateAdmin.css?vue&type=style&index=0&id=76acf387&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76acf387"]])

export default __exports__